import { render, staticRenderFns } from "./officialVehiclesListDetail.vue?vue&type=template&id=38104843&scoped=true&"
import script from "./officialVehiclesListDetail.vue?vue&type=script&lang=js&"
export * from "./officialVehiclesListDetail.vue?vue&type=script&lang=js&"
import style0 from "./officialVehiclesListDetail.vue?vue&type=style&index=0&id=38104843&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38104843",
  null
  
)

export default component.exports